module.exports = __webpack_public_path__ + "img/score10.86e8461f.png";